import type { FC, ReactElement } from 'react';
import { useMemo } from 'react';

import { useCashierCallbackConnected } from '../../../hooks/useCashierCallbackConnected';
import { useCoreDispatch } from '../../../store/CoreStore';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { ButtonVariant } from '../../controls/button/Button';
import { PopupType } from '../../popup/types';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const InsufficientFundsConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const cashierCallback = useCashierCallbackConnected();

  const actions: BlockingModalActionButton[] = useMemo(() => {
    const actions: BlockingModalActionButton[] = [
      {
        tk: cashierCallback ? 'NOTHANKS' : 'OK',
        type: cashierCallback ? ButtonVariant.MAIN : ButtonVariant.ACCENT,
        click: (): void => {
          dispatch(gameStateActions.setBalanceCheckCount(0));
          dispatch(popupActions.dismissPopup(PopupType.InsufficientFunds));
        },
      },
    ];
    if (cashierCallback) {
      actions.push({
        tk: 'TAKEMETHERE',
        type: ButtonVariant.ACCENT,
        click: (): void => {
          dispatch(gameStateActions.setBalanceCheckCount(0));
          dispatch(popupActions.dismissPopup(PopupType.InsufficientFunds));
          cashierCallback();
        },
      });
    }
    return actions;
  }, [cashierCallback, dispatch]);

  return (
    <BlockingModalContent
      titleTk="INSUFFICIENTFUNDS"
      messageTk={cashierCallback ? 'LOWBALANCE' : 'LOWBALANCE_SHORT'}
      actions={actions}
    />
  );
};
